export const visibleBySectionPermission = (permissions = [], sectionSlug = '' || [], modifier = 'and') => {
  if (!permissions?.length) return false;

  const bySectionSlug = (permission) => permission.slug === sectionSlug;
  const permissionSlugs = permissions.map((permission) => permission.slug);
  const inPermissions = (slug) => permissionSlugs.includes(slug);

  if (typeof sectionSlug === 'string') {
    return !!permissions.find(bySectionSlug);
  }

  if (Array.isArray(sectionSlug)) {
    if (modifier === 'and') return sectionSlug.filter(inPermissions).length === sectionSlug.length;
    if (modifier === 'or') return sectionSlug.some(inPermissions);
    if (modifier === 'not') return !sectionSlug.every(inPermissions);

    return false;
  }

  return false;
}
